// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"55":"1eb72d8e","587":"17b07e55","673":"10a7ba48"}[chunkId] + ".chunk.css";
};